/**
 * One script for all announcement bars: set data-announcement-carousel on the root.
 * Design mode: <html class="shopify-design-mode"> (Horizon / theme.liquid).
 */
(function () {
  function isDesignMode() {
    return document.documentElement.classList.contains('shopify-design-mode');
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-announcement-init') === '1') return;
    root.setAttribute('data-announcement-init', '1');

    var track = root.querySelector('.announcement-swiper__track');
    if (!track) return;

    var countReal = track.children.length;
    if (countReal <= 1) return;

    var designMode = isDesignMode();
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms') || '5000', 10) || 5000;
    var index = 0;
    var count;
    var timer;
    var startX = 0;
    var dragging = false;
    var dragDx = 0;
    var width = 0;

    function slideWidth() {
      return root.getBoundingClientRect().width || 1;
    }

    function goTo(i, animate) {
      index = i;
      width = slideWidth();
      if (animate === false) {
        track.classList.add('is-dragging');
        track.style.transform = 'translate3d(' + -index * width + 'px,0,0)';
        void track.offsetWidth;
        track.classList.remove('is-dragging');
      } else {
        track.classList.remove('is-dragging');
        track.style.transform = 'translate3d(' + -index * width + 'px,0,0)';
      }
    }

    function next() {
      if (!designMode && index >= countReal) {
        goTo(0, false);
        return;
      }
      if (index < count - 1) {
        goTo(index + 1, true);
      } else if (designMode) {
        goTo(0, false);
      }
    }

    function prev() {
      if (index === 0) {
        goTo(countReal - 1, true);
      } else {
        goTo(index - 1, true);
      }
    }

    function onTransitionEnd(e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      if (!designMode && index === count - 1) {
        goTo(0, false);
      }
    }

    if (!designMode) {
      var clone = track.children[0].cloneNode(true);
      clone.classList.add('announcement-swiper__slide--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      track.appendChild(clone);
    }

    count = track.children.length;
    track.addEventListener('transitionend', onTransitionEnd);

    function armAutoplay() {
      clearInterval(timer);
      timer = setInterval(next, autoplayMs);
    }

    goTo(0, true);
    armAutoplay();

    window.addEventListener(
      'resize',
      function () {
        goTo(index, false);
      },
      { passive: true }
    );

    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      dragDx = 0;
      clearInterval(timer);
      width = slideWidth();
      try {
        root.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dragDx = e.clientX - startX;
      track.classList.add('is-dragging');
      track.style.transform = 'translate3d(' + (-index * width + dragDx) + 'px,0,0)';
    });

    root.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      try {
        root.releasePointerCapture(e.pointerId);
      } catch (err) {}

      var threshold = Math.max(48, width * 0.12);
      if (dragDx < -threshold) {
        next();
      } else if (dragDx > threshold) {
        prev();
      } else {
        goTo(index, true);
      }
      dragDx = 0;
      armAutoplay();
    });

    root.addEventListener('pointercancel', function () {
      dragging = false;
      goTo(index, true);
      dragDx = 0;
      armAutoplay();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-announcement-carousel]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
